<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
      <!-- <v-btn v-on="on" text>
        <v-icon class="mr-2">mdi-tune-variant</v-icon>
        Filtro
      </v-btn> -->
    </template>

    <v-card>
      <v-container>
        <v-switch
          v-model="filters.ativo"
          true-value="S"
          false-value="N"
          :label="`${filters.ativo == 'S' ? 'Ativo' : 'Inativo'}`"
          @change="handleFilter()"
        ></v-switch>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Segmento"
          item-text="descricao"
          item-value="id_band"
          service="sistemaService.tipoBandeiras"
          v-model="filters.id_band"
          :filters="{ id_band: '2,4' }"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-domain"
          clearable
          single-line
          label="Empresa"
          item-text="apelido"
          item-value="id_empresa"
          service="sistemaService.empresa"
          :filters="{
            id_band: filters.id_band,
            calcula_comissao: 'S'
          }"
          v-model="filters.id_empresa"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-account"
          clearable
          single-line
          label="Função"
          item-text="descricao"
          item-value="id_funcao"
          service="sistemaService.funcoes"
          :filters="{ id_band: filters.id_band, ativo: 'S' }"
          v-model="filters.id_funcao"
          :hasCode="true"
          @change="handleFilter()"
        />

        <BaseFilter
          label="Departamento"
          v-model="filters.id_depto"
          service="comissaoService.departamentos"
          item-text="departamento"
          item-value="id_depto"
          single-line
          prepend-inner-icon="mdi-toolbox"
          clearable
          :multiple="false"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-account"
          clearable
          single-line
          label="Colaboradores"
          item-text="colaborador"
          item-value="id_colaborador"
          service="sistemaService.colaboradorEmpresa"
          :filters="{
            id_empresa: filters.id_empresa,
            id_funcao: filters.id_funcao,
            id_band: filters.id_band,
            id_depto: filters.id_depto,
            ativo: 'S'
          }"
          v-model="filters.id_colaborador"
          :hasCode="true"
          @change="handleFilter()"
        >
        </BaseFilter>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import FilterBottom from "@/components/shared/bottons/FilterBottom";
import BaseFilter from "@/components/shared/BaseSelectService";
export default {
  name: "FilterComissao",

  components: {
    BaseFilter,
    FilterBottom
  },

  data() {
    return {
      filters: {
        ativo: "S"
      }
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    }
  }
};
</script>
<style scoped></style>
